import styled from 'styled-components';

export const Viewport = styled.div<{ $canDrag: boolean }>`
  width: 100%;
  height: 100%;
  overflow: hidden;
  touch-action: ${({ $canDrag }) => ($canDrag ? 'pan-y pinch-zoom' : 'auto')};
`;

export const Rail = styled.div`
  display: flex;
  align-items: stretch;
  height: 100%;
  gap: 10px;
  will-change: transform;
  transform: translate3d(0, 0, 0);
`;

export const Slide = styled.div<{ $mode: 'single' | 'auto'; $ratio: number }>`
  position: relative;
  flex: 0 0 ${({ $mode }) => ($mode === 'single' ? '100%' : 'auto')};
  width: ${({ $mode }) => ($mode === 'single' ? '100%' : 'auto')};
  height: 100%;
  max-width: 100vw;
  aspect-ratio: ${({ $mode, $ratio }) => ($mode === 'auto' ? $ratio : 'auto')};
  display: flex;
  align-items: stretch;
  justify-content: center;
  z-index: 0;

  &[data-active='true'] {
    z-index: 2;
  }
`;
